(ns common.mandatory
  (:require [common.rules :as rules]))

(def mandatoriness-keys [:mandatory/always
                         :mandatory/when-visible
                         :mandatory/optional
                         :mandatory/conditional
                         :mandatory/conditional-when-visible])

(defn icon
  [mandatoriness]
  (case mandatoriness
    :mandatory/always "fa-solid fa-circle-exclamation"
    :mandatory/when-visible "fa-solid fa-circle-exclamation"
    :mandatory/conditional "fa-light fa-circle-question"
    :mandatory/conditional-when-visible "fa-light fa-circle-question"
    :mandatory/optional "fa-light fa-circle"
    "fa-solid fa-unknown"))

(defn calc-mandatoriness
  [visible? value-lookup mandatoriness mandatoriness-rules]
  (case mandatoriness
    :mandatory/always   true
    :mandatory/optional false
    :mandatory/when-visible visible?
    :mandatory/conditional-when-visible
    (and visible? (rules/rules-pass? value-lookup mandatoriness-rules))
    :mandatory/conditional
    (rules/rules-pass? value-lookup mandatoriness-rules)
    (do (println "Unknown mandatoriness " mandatoriness)
        false)))
